import { create } from 'zustand';

interface CustomCollapseState {
  activeKey: string | null;
  setActiveKey: (key: string | null) => void;
}

export const useCustomCollapseStore = create<CustomCollapseState>((set) => ({
  activeKey: null,
  setActiveKey: (key) => set({ activeKey: key }),
})); 